function topImg() {
  const items = document.querySelectorAll('.p-index-merit__img');
  const hovers = document.querySelectorAll('.p-index-merit__img-circle-hover');

  if (!items.length) return;

  items.forEach((item) => {
    // item01 みたいなクラス取得
    const itemClass = [...item.classList].find((c) => c.startsWith('item'));

    item.addEventListener('mouseenter', () => {
      // 画像側
      items.forEach((i) => i.classList.toggle('is-active', i !== item));

      // hover側
      hovers.forEach((hover) => {
        const hoverClass = [...hover.classList].find((c) => c.startsWith('item'));

        hover.classList.toggle('is-active', hoverClass === itemClass);
      });
    });

    item.addEventListener('mouseleave', () => {
      items.forEach((i) => i.classList.remove('is-active'));
      hovers.forEach((hover) => hover.classList.remove('is-active'));
    });
  });
}

export { topImg };
